<button
  class="az-button"
  [class.az-button--icon-right]="iconPosition === 'right'"
  [class.az-button--default]="variant === 'default'"
  [class.az-button--primary]="variant === 'primary'"
  [disabled]="disabled"
>
  <span
    *ngIf="showIcon && icon && iconPosition === 'left'"
    class="material-symbols-outlined az-button__icon"
  >
    {{ icon }}
  </span>
  <span *ngIf="label" class="az-button__label">{{ label }}</span>
  <span
    *ngIf="showIcon && icon && iconPosition === 'right'"
    class="material-symbols-outlined az-button__icon"
  >
    {{ icon }}
  </span>
</button>
